<div *ngIf="loaded && !isMetasObjetivos">

    <app-profile-header 
        *ngIf="profile" 
        [isAdmin]="isAdmin" 
        [isStudent]="isStudent" 
        [personalData]="personalData" 
        [user_id]="id"
        [training]="training" 
        [disableSave]="disableSave" 
        [avatarUrl]="avatarUrl" 
        [status]="profile.estado" 
        [usuarioId]="usuarioId"
        [datosTraining]="datosTraining" 
        [email]="profile.email"
        (updateDataEvent)='getUserProfileData()'>
    </app-profile-header>

    <mat-tab-group mat-stretch-tabs *ngIf="isAdmin && !isMobile" mat-align-tabs="center">
        <mat-tab *ngIf="estado != 'C' " label="Datos">
            <div class="mat-tab-background">
                <app-all-data
                *ngIf="estado"
                    (editPersonalEvent)='editPersonal($event)' 
                    (editPhysiologicalEvent)='editPhysiological($event)' 
                    (editBankEvent)='editBank($event)'
                    (editContactEvent)='editContact($event)'
                    [personalData]="personalData"
                    [contactData]="contactData"
                    [physiologicalData]="physiologicalData"
                    [alumnosDatosBancario]="alumnosDatosBancario">
                </app-all-data>
            </div>
        </mat-tab>
        <mat-tab *ngIf="estado != 'C' " label="Antecedentes y objetivos">
            <div class="mat-tab-background">
                <br />
                <app-background-objetives [showAntecedentes]="true" [showMarcasObjetivos]="true" [allAchievements]="allAchievements" [antecedente]="antecedente"
                    [objetives]="objetives">
                </app-background-objetives>
            </div>
        </mat-tab>
        <mat-tab *ngIf="estado != 'C' " label="Planes">
            <!-- <app-calendar></app-calendar> -->
            <div class="mat-tab-background">
                <div class="tabContent">
                    <app-week [showDownload]="true" [alumnoId]="id" [isAdmin]="false"></app-week>
                    <app-feedback [canGiveFeedback]="false" [edit]="true"></app-feedback>
                </div>
            </div>
        </mat-tab>
        <div class="mat-tab-background">
            <br />
        </div>
        <mat-tab label="Registro de estados">
            <div class="mat-tab-background">
                <app-status-register-card [estado]="profile.estado" [alumnoId]="id" [usuarioId]="usuarioId" [motivoBaja]="motivoBaja "></app-status-register-card>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div *ngIf="isMobile">
        <br/>
    </div>
    <mat-tab-group *ngIf="isAdmin && isMobile" mat-align-tabs="center" [disableRipple]="true">
        <mat-tab *ngIf="estado != 'C' " label="Datos">
            <div class="mat-tab-background">
                <app-all-data
                    (editPersonalEvent)='editPersonal($event)' 
                    (editPhysiologicalEvent)='editPhysiological($event)' 
                    (editBankEvent)='editBank($event)'
                    (editContactEvent)='editContact($event)'
                    [personalData]="personalData"
                    [contactData]="contactData"
                    [physiologicalData]="physiologicalData"
                    [alumnosDatosBancario]="alumnosDatosBancario">
                </app-all-data>
            </div>
        </mat-tab>
        <mat-tab *ngIf="estado != 'C' " label="Antecedentes y objetivos">
            <div class="mat-tab-background">
                <br />
                <app-background-objetives [showAntecedentes]="true" [showMarcasObjetivos]="true" [allAchievements]="allAchievements" [antecedente]="antecedente"
                    [objetives]="objetives">
                </app-background-objetives>
            </div>
        </mat-tab>
        <mat-tab *ngIf="estado != 'C' " label="Planes">
            <div class="mat-tab-background">
                <div class="tabContent">
                    <app-week [showDownload]="true" [alumnoId]="id" [isAdmin]="false"></app-week>
                    <app-feedback [canGiveFeedback]="false" [edit]="true"></app-feedback>
                </div>
            </div>
        </mat-tab>
        <div class="mat-tab-background">
            <br />
        </div>
        <mat-tab label="Registro de estados">
            <div class="mat-tab-background">
                <app-status-register-card 
                    [estado]="profile.estado" 
                    [alumnoId]="id" 
                    [usuarioId]="usuarioId" 
                    [motivoBaja]="motivoBaja">
                </app-status-register-card>
            </div>
        </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs *ngIf="isStudent" mat-align-tabs="center">
        <mat-tab label="Datos">
            <div class="mat-tab-background">
                <app-all-data
                    (editPersonalEvent)='editPersonal($event)' 
                    (editPhysiologicalEvent)='editPhysiological($event)' 
                    (editBankEvent)='editBank($event)'
                    (editContactEvent)='editContact($event)'
                    [personalData]="personalData"
                    [contactData]="contactData"
                    [physiologicalData]="physiologicalData"
                    [alumnosDatosBancario]="alumnosDatosBancario">
                </app-all-data>
            </div>
        </mat-tab>
        <mat-tab [disabled]="estado != 'A' " label="Antecedentes">
            <div class="mat-tab-background">
                <br />
                <app-background-objetives [showAntecedentes]="true" [showMarcasObjetivos]="false" [allAchievements]="allAchievements" [antecedente]="antecedente"
                    [objetives]="objetives">
                </app-background-objetives>
            </div>
        </mat-tab>
        <div class="mat-tab-background">
            <br />
        </div>
    </mat-tab-group>

</div>

<div class="metasObjetivos" *ngIf="loaded && isMetasObjetivos">
    <div *ngIf="!isMobile">
        <p class="headline4" >{{'profile.tabsTitles.achievementsObjetives' | translate}}</p>
        <br />
    </div>
    <div *ngIf="isMobile">
        <br/>
        <p class="flexLeft headline5">{{'profile.tabsTitles.achievementsObjetives' | translate}}</p>
    </div>
    <app-background-objetives [showAntecedentes]="false" [showMarcasObjetivos]="true" [allAchievements]="allAchievements" [antecedente]="antecedente"
                    [objetives]="objetives">
    </app-background-objetives>
    <br />
</div>